import { Slider } from "@/components/ui/slider";
import { cn } from "@/lib/utils";

interface ConstantSumSliderProps {
  value: number;
  max: number;
  step?: number;
  onChange: (value: number) => void;
  onDragStart?: () => void;
  onDragEnd?: () => void;
  className?: string;
  baselineClassName?: string;
}

export const ConstantSumSlider = ({
  value,
  max,
  step = 1,
  onChange,
  onDragStart,
  onDragEnd,
  className,
  baselineClassName,
}: ConstantSumSliderProps) => {
  return (
    <div className="relative mt-2">
      <div
        className={cn(
          "absolute inset-0 h-2 rounded-full bg-gray-300 dark:bg-gray-700",
          baselineClassName,
        )}
      />
      <Slider
        value={[value]}
        max={max}
        step={step}
        onPointerDown={onDragStart}
        onValueChange={(val) => onChange(val[0])}
        onValueCommit={onDragEnd}
        className={cn("relative z-10", className)}
      />
    </div>
  );
};
